import { render } from "./App.vue?vue&type=template&id=1a39bcf9"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1a39bcf9&lang=less"

import exportComponent from "/opt/1panel/www/sites/mp.longyaonet.com/index/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__